module.exports = __webpack_public_path__ + "img/logo.e08dab2d.png";